// Consistent "return to where you were" handling for every place in the app
// that redirects an unauthenticated/session-expired user to /login.

const STORAGE_KEYS = {
  RETURN_PATH: "teco-return-path",
};

const RETURN_PATH_TTL_MS = 30 * 60 * 1000; // 30 minutes

const NO_RETURN_PATHS = ["/login", "/register", "/auth/verify", "/auth/reset"];

export function saveReturnPath(location) {
  if (!location || NO_RETURN_PATHS.includes(location.pathname)) return;

  const path = `${location.pathname}${location.search ?? ""}${location.hash ?? ""}`;
  localStorage.setItem(
    STORAGE_KEYS.RETURN_PATH,
    JSON.stringify({ path, savedAt: Date.now() })
  );
}

export function consumeReturnPath() {
  const raw = localStorage.getItem(STORAGE_KEYS.RETURN_PATH);
  if (!raw) return null;
  localStorage.removeItem(STORAGE_KEYS.RETURN_PATH);

  try {
    const { path, savedAt } = JSON.parse(raw);
    if (!path || Date.now() - savedAt > RETURN_PATH_TTL_MS) return null;
    return path;
  } catch {
    return null;
  }
}

export function goToLogin(navigate, location) {
  saveReturnPath(location);
  navigate("/login", { replace: true });
}
